// @flow
import { Field, useFormikContext } from 'formik'
import * as React from 'react'
import ToggleField from 'ui/molecules/ToggleField'

type Props = {
  name: string,
}

function FormikToggleField({ name, ...rest }: Props): React.Node {
  const { setFieldValue, values } = useFormikContext()

  const onChange = React.useCallback(() => {
    setFieldValue(name, !values[name])
  }, [name, setFieldValue, values])

  return (
    <Field
      {...rest}
      component={ToggleField}
      name={name}
      onChange={onChange}
      value={values[name]}
    />
  )
}

export default FormikToggleField
